// Restore AI wording in older public guides retained in the database.
// Preserve brands, addresses and inline code rather than rewriting integrations.
const TERMS = /<code\b[^>]*>[\s\S]*?<\/code>|`[^`]*`|(?:https?:\/\/|mailto:|@)[^\s<>"']+|\b[\w.+-]+@[\w.-]+\.[a-z]+|\b(?:Gab[ .-]AI|Galaxy AI|Google AI Studio|Vercel AI SDK|AI SDK|AI Studio|Magica AI)\b|\b(?:[\w-]+\.)+(?:ai|com|org|net)\b|\/[\w][\w/?.#=:%+-]*|\b(?:[Aa] )?Super Intelligence\b/g;

function publicCopy(text) {
  if (typeof text !== 'string') return text;
  return text.replace(TERMS, match => {
    if (match === 'Super Intelligence') return 'AI';
    if (match === 'A Super Intelligence') return 'An AI';
    if (match === 'a Super Intelligence') return 'an AI';
    return match;
  });
}

const COPY_FIELDS = new Set([
  'title', 'name', 'label', 'description', 'copy', 'text', 'keywords', 'searchKeywords',
  'badge', 'articleSection', 'audience', 'about', 'teaches', 'items', 'options',
  'question', 'answer', 'q', 'a', 'explanation', 'prerequisites', 'lessonTopic',
  'goodCaption', 'badCaption', 'caption', 'alt', 'heading', 'summary', 'supportNotes',
  'labels', 'headline', 'lede', 'tagline', 'desc', 'detail', 'feature', 'benefit',
  'subtitle', 'eyebrow', 'problem', 'solution', 'capabilities', 'cta', 'ctaSubtext', 'prompt',
]);

function publicGuideCopy(value, field) {
  if (typeof value === 'string') return COPY_FIELDS.has(field) ? publicCopy(value) : value;
  if (value?.$isSubdocument && typeof value.toObject === 'function') return publicGuideCopy(value.toObject(), field);
  if (Array.isArray(value)) {
    const next = value.map(item => publicGuideCopy(item, field));
    return next.some((item, index) => item !== value[index]) ? next : value;
  }
  if (!value || typeof value !== 'object' || Object.getPrototypeOf(value) !== Object.prototype) return value;
  const entries = Object.entries(value).map(([key, item]) => [key, publicGuideCopy(item, key)]);
  return entries.some(([key, item]) => item !== value[key]) ? Object.fromEntries(entries) : value;
}

module.exports = { publicCopy, publicGuideCopy };
